import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'clientAbbreviation' })
export class ClientAbbreviationPipe implements PipeTransform {
  transform(clientName: string | undefined | null): string {
    if (!clientName) {
      return '';
    }
    return clientName
      .split(/\s+/)
      .filter((w) => w.length > 0)
      .map((w) => w[0].toUpperCase())
      .join('');
  }
}
